import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  topHeaderText: '',
  loading: false,
  userData: {},
  permission: {}
}
export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    updateTopHeader: (state, action) => {
      state.topHeaderText = action.payload
    },
    updateLoading: (state, action) => {
      state.loading = action.payload
    },
    updateUserData: (state, action) => {
      state.userData = action.payload
    },
    updatePermission: (state, action) => {
      state.permission = action.payload
    }
  }
})

export const { updateTopHeader, updateLoading, updateUserData, updatePermission } =
  commonSlice.actions
export default commonSlice.reducer
